import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = "nav.menu-global ul#main-menu";

export default function loadSideMenu(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
